import { atom } from 'jotai'
import { IUser } from '../services/authentication.service'

export const authAtom = atom<Partial<IUser>>({})
